import { useState } from "react";
import { Link } from "react-router-dom";
import { Navbar, Nav, Container, Button, NavDropdown } from "react-bootstrap";
import { Logo } from "../general/Logo";
import { LanguageSwitcher } from "../general/LanguageSwitcher";
import {
  HOME_ROUTE,
  ABOUT_ROUTE,
  SCHOOL_RESOURCES_ROUTE,
  SIGNUP_ROUTE,
  LOGIN_ROUTE,
  TEACHERS_RESOURCES_ROUTE,
  PARENTS_RESOURCES_ROUTE,
  FEATURES_ROUTE,
  PRICING_ROUTE,
} from "../../routes/RoutesPathes";
import { useTranslation } from "react-i18next";

export const Header = () => {
  const [expanded, setExpanded] = useState(false);
  const { t } = useTranslation();

  const toggleNav = () => {
    setExpanded(!expanded);
  };

  const collapseNav = () => {
    setExpanded(false);
  };

  return (
    <header>
      <Navbar expand="lg" className="s-nav bg-light" fixed="top" expanded={expanded} onToggle={setExpanded}>
        <Container>
          <Navbar.Brand as={Link} to={HOME_ROUTE}>
            <Logo width="170" />
          </Navbar.Brand>

          {/* Mobile Toggle Button */}
          <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={toggleNav} />

          {/* Navigation Links */}
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav>
              <Nav.Link as={Link} to={HOME_ROUTE} onClick={collapseNav}>{t("pages.home")}</Nav.Link>
              <Nav.Link as={Link} to={ABOUT_ROUTE} onClick={collapseNav}>{t("pages.about")}</Nav.Link>
              <Nav.Link as={Link} to={FEATURES_ROUTE} onClick={collapseNav}>{t("pages.features")}</Nav.Link>
              <Nav.Link as={Link} to={PRICING_ROUTE} onClick={collapseNav}>{t("pages.pricing")}</Nav.Link>
              <NavDropdown title={t("pages.resources")} id="basic-nav-dropdown">
                <NavDropdown.Item as={Link} to={SCHOOL_RESOURCES_ROUTE} onClick={collapseNav}>{t("pages.school_resources")}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to={TEACHERS_RESOURCES_ROUTE} onClick={collapseNav}>{t("pages.teachers_resources")}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to={PARENTS_RESOURCES_ROUTE} onClick={collapseNav}>{t("pages.parent_resources")}</NavDropdown.Item>
              </NavDropdown>
            </Nav>
            <Nav>
              <Nav.Link as={Link} to={LOGIN_ROUTE} onClick={collapseNav}>{t("pages.login")}</Nav.Link>
              <Button 
                as={Link}
                to={SIGNUP_ROUTE}
                onClick={collapseNav}
                variant="primary"
              >
                {t("buttons.join_now")}
              </Button>
              <LanguageSwitcher onClick={collapseNav} />
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  );
};
